import React from 'react';

import Box from '../Box';
import { Wrapper } from "./ACommonStyles";
import { getPcsUrls } from "./AHelpers";


export default props => {
	const size = window.innerWidth > 996;
	const pcs = getPcsUrls(props.settings.settings?.pcs_background_mobile, props.settings.settings?.pcs_background_desktop);

	return (
		<section className="container">
			<Wrapper className="row" pcs={pcs}>
				<div className="col-xs-12 col-md-4">
					<Box {...props} id="b1" type="BPhotoOnTop" settings={props.settings.b1} size={size} classes="" />
				</div>
				<div className="col-xs-12 col-md-4">
					<Box {...props} id="b2" type="BPhotoOnTop" settings={props.settings.b2} size={size} classes="" />
				</div>
				<div className="col-xs-12 col-md-4">
					<Box {...props} id="b3" type="BPhotoOnTop" settings={props.settings.b3} size={size} classes="" />
				</div>
			</Wrapper>
		</section>
	);
}
